module.exports = __webpack_public_path__ + "static/media/ResumeSG.5b1dec52.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Components/ResumeSG.pdf
// module id = 39
// module chunks = 0